import {createSlice} from '@reduxjs/toolkit';

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState: {
    loading: true,
    comparisonLoading: false,
    compareByToggle: false,
    operationsData: [],
    compareByOperationsData: [],
    areaSummaries: [],
    compareByAreaSummaries: [],
    taskConfigsDict: {},
    implementDict: {},
    vehicleSNDict: {},
    vehicleLabelDict: {},
    zonesDict: {
      block: {},
      field: {},
      region: {},
      nonAcArea: {},
    },
    triggerRefreshData: false,
    refreshInProgress: false,
    statsviewRangeSelected: false,
    scorecards: [],
    scorecardsIdDict: {},
    kpiLandingPageOn: true,
    selectedKPI: '',
    selectedSubset: '',

    filterOptions: {
      sortByAlpha: [
        {value: 'desc', text: 'Descending'},
        {value: 'asc', text: 'Ascending'},
        {value: 'alphabetical', text: 'Alphabetical'},
      ],
      sortByChrono: [
        {value: 'desc', text: 'Descending'},
        {value: 'asc', text: 'Ascending'},
        {value: 'chronological', text: 'Chronological'},
      ],
      displayLimit: [
        {value: 0, text: 'Show All'},
        {value: 10, text: 'Show 10'},
        {value: 25, text: 'Show 25'},
        {value: 50, text: 'Show 50'},
      ],
      block: [],
      field: [],
      region: [],
      rowSpacing: [],
      vehicle: [],
      vehicleType: [],
      task: [],
      taskType: [],
      operator: [],
      otherArea: [],
      otherAreaType: [],
    },
    servicesData: null,
    compareByServicesData: null,
    stalestGenTime: null,
    inspectionsData: null,
    compareByInspectionsData: null,
    inspectionsDict: null,
    installTypes: {},
    selectedScorecardPageIndex: null,
    selectedScorecardId: null,
    scorecardsIdDict: {},
    editScorecardsIdDict: {},
    compareByDatesCache: {start: null, end: null},
    compareAlertStatsData: null,
    alertStatsCache: null,
    alertCustomerRulesDict: {},
    dates: {start: null, end: null},
    addToScorecardTrigger: false,
    activeDevices: {
      'geotab': {},
      'samsara': {},
      'johndeere': {},
    },
    industryData: [],
    industryLoading: false,
    industryLoaded: false,
    currentCustomerMarkets: [],
    industryMetricsSharingDisabled: false,
    inspectionRatesViewBy: 'total',
  },
  reducers: {
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setVehicles(state, action) {
      state.vehicleSNDict = action.payload;
    },
    setVehicleLabels(state, action) {
      state.vehicleLabelDict = action.payload;
    },
    setTaskConfigs(state, action) {
      state.taskConfigsDict = action.payload;
    },
    setImplementDict(state, action) {
      state.implementDict = action.payload;
    },
    setZonesDict(state, action) {
      state.zonesDict = action.payload;
    },
    setOperationsData(state, action) {
      state.operationsData = action.payload;
    },
    setAreaSummaries(state, action) {
      state.areaSummaries = action.payload;
    },
    setCompareByAreaSummaries(state, action) {
      state.compareByAreaSummaries = action.payload;
    },
    setFilterOptions(state, action) {
      const currentFilterOptions = state.filterOptions;
      const newOptions = action.payload;

      Object.keys(newOptions).forEach((key) => {
        currentFilterOptions[key] = newOptions[key];
      });

      state.filterOptions = currentFilterOptions;
    },
    setStalestGenTime(state, action) {
      state.stalestGenTime = action.payload;
    },
    setScorecards(state, action) {
      state.scorecards = action.payload;
      if (action.payload.length > 0) {
        const newScorecardsIdDict = {};
        for (let i = 0; i < action.payload.length; i++) {
          const tempScorecardId = action.payload[i]['data'].id;
          newScorecardsIdDict[tempScorecardId] = action.payload[i]['data'];
          newScorecardsIdDict[tempScorecardId].pages.forEach((page, index) => {
            page.originalPageIndex = index;
          });
        }
        state.scorecardsIdDict = newScorecardsIdDict;
        state.editScorecardsIdDict = newScorecardsIdDict;
      }
    },
    setEditScorecardsIdDict(state, action) {
      state.editScorecardsIdDict = action.payload;
    },
    setSelectedScorecardId(state, action) {
      state.selectedScorecardId = action.payload;
    },
    setSelectedKPI(state, action) {
      state.selectedKPI = action.payload;
    },
    setSelectedSubset(state, action) {
      state.selectedSubset = action.payload;
    },
    setServicesData(state, action) {
      state.servicesData = action.payload;
    },
    setCompareByServicesData(state, action) {
      state.compareByServicesData = action.payload;
    },
    setCompareByDatesCache(state, action) {
      state.compareByDatesCache = action.payload;
    },
    setCompareAlertStatsData(state, action) {
      state.compareAlertStatsData = action.payload;
    },
    setAlertStatsCache(state, action) {
      state.alertStatsCache = action.payload;
    },
    setAlertCustomerRulesDict(state, action) {
      state.alertCustomerRulesDict = action.payload && typeof action.payload === 'object' ? action.payload : {};
    },
    setCompareByOperationsData(state, action) {
      state.compareByOperationsData = action.payload;
    },
    setCompareByToggle(state, action) {
      state.compareByToggle = action.payload;
    },
    setSelectedScorecardPageIndex(state, action) {
      state.selectedScorecardPageIndex = action.payload;
    },
    setInspectionsData(state, action) {
      state.inspectionsData = action.payload;
    },
    setCompareByInspectionsData(state, action) {
      state.compareByInspectionsData = action.payload;
    },
    setComparisonLoading(state, action) {
      state.comparisonLoading = action.payload;
    },
    setInstallTypes(state, action) {
      state.installTypes = action.payload;
    },
    setDatesCache(state, action) {
      state.dates = action.payload;
    },
    setInspectionsDict(state, action) {
      state.inspectionsDict = action.payload;
    },
    setkpiLandingPageOn(state, action) {
      state.kpiLandingPageOn = action.payload;
    },
    updateAddToScorecardTrigger(state) {
      state.addToScorecardTrigger = !state.addToScorecardTrigger;
    },
    setTriggerRefreshData(state, action) {
      state.triggerRefreshData = action.payload;
    },
    setRefreshInProgress(state, action) {
      state.refreshInProgress = action.payload;
    },
    setStatsviewRangeSelected(state, action) {
      state.statsviewRangeSelected = action.payload;
    },
    updateActiveDevices(state, action) {
      const devicesActive = JSON.parse(JSON.stringify(action.payload));
      state.activeDevices = devicesActive;
    },
    setIndustryData(state, action) {
      state.industryData = action.payload.allDataDict;
      state.currentCustomerMarkets = action.payload.currentCustomerMarkets || [];
      state.industryMetricsSharingDisabled = action.payload.industryMetricsSharingDisabled;
      state.industryLoading = false;
      state.industryLoaded = true;
    },
    setIndustryLoading(state, action) {
      state.industryLoading = action.payload;
    },
    setInspectionRatesViewBy(state, action) {
      state.inspectionRatesViewBy = action.payload;
    },
  },
});

export const {
  setCompareByToggle,
  setSelectedKPI,
  setSelectedSubset,
  setServicesData,
  setOperationsData,
  setAreaSummaries,
  setCompareByAreaSummaries,
  setTaskConfigs,
  setImplementDict,
  setInspectionsData,
  setCompareByServicesData,
  setCompareByOperationsData,
  setCompareByInspectionsData,
  setCompareByDatesCache,
  setCompareAlertStatsData,
  setAlertStatsCache,
  setAlertCustomerRulesDict,
  setComparisonLoading,
  setFilterOptions,
  setLoading,
  setInstallTypes,
  setDatesCache,
  setVehicles,
  setZonesDict,
  setInspectionsDict,
  setkpiLandingPageOn,
  setScorecards,
  setSelectedScorecardId,
  setSelectedScorecardPageIndex,
  setEditScorecardsIdDict,
  setVehicleLabels,
  updateAddToScorecardTrigger,
  setStalestGenTime,
  setTriggerRefreshData,
  setRefreshInProgress,
  setStatsviewRangeSelected,
  updateActiveDevices,
  setIndustryData,
  setIndustryLoading,
  setInspectionRatesViewBy,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
